import React, {useEffect, useState} from 'react';
import {DataGrid, GridToolbar} from '@mui/x-data-grid';
import {styled} from '@mui/system';

function formatCurrency(value) {
    if (typeof value !== 'undefined' && value !== null && value !== '') {
        return Number(value).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    }
    return '';
}

const StyledDataGrid = styled(DataGrid)(() => ({
    '& .MuiDataGrid-row': {
        '&:nth-child(even)': {
            backgroundColor: '#eaf0f5',
        },
    },
    '& .MuiDataGrid-columnHeaderTitle': {
        fontWeight: 'bold',
    },
    '& .MuiDataGrid-cell': {
        whiteSpace: 'normal !important',
        wordWrap: 'break-word',
    },
    '& .total-row': {
        backgroundColor: '#f8fff9',
        fontWeight: 'bold',
    },
}));

function processData(data) {
    if (!data || !Array.isArray(data) || data.length === 0) return [];

    const processedData = data.map((row) => ({
        ...row.value,
        id: row.value.id,
    }));

    if (processedData.length > 1 && processedData[0].id === 'total') {
        const totalRow = processedData.shift();
        totalRow.total = true;
        processedData.push(totalRow);
    }

    return processedData;
}

const PartnerRevenueDataGrid = ({data}) => {
    const [rows, setRows] = useState(processData(data));

    useEffect(() => {
        setRows(processData(data));
    }, [data]);

    const hasCompany = rows.some((row) => 'company' in row);
    const hasCompanyType = rows.some((row) => 'company_type' in row);
    const hasIrtbId = rows.some((row) => 'irtb_id' in row);
    const hasConnection = rows.some((row) => 'connection' in row);
    const hasCurrency = rows.some((row) => 'currency' in row);
    const hasPartnerCode = rows.some((row) => 'partner_code' in row);

    const columns = [
        {field: 'partner', headerName: 'Partner', width: 180},
        {
            field: 'revenue',
            headerName: 'Revenue, $',
            width: 160,
            valueFormatter: (params) => formatCurrency(params.value),
        },
    ];

    if (hasCompany) columns.push({field: 'company', headerName: 'Company', width: 200});
    if (hasCompanyType) columns.push({field: 'company_type', headerName: 'Company type', width: 130});
    if (hasIrtbId) columns.push({field: 'irtb_id', headerName: 'iRTB ID', width: 100});
    if (hasConnection) columns.push({field: 'connection', headerName: 'Connection', width: 200});
    if (hasCurrency) columns.push({field: 'currency', headerName: 'Currency', width: 110});
    if (hasPartnerCode) columns.push({field: 'partner_code', headerName: 'Partner code', width: 150});

    if (!rows.length) {
        return <div></div>;
    }

    return (
        <div style={{height: 640, width: '100%'}}>
            <StyledDataGrid
                rows={rows}
                columns={columns}
                pageSize={25}
                getRowId={(row) => row.id}
                getRowClassName={(params) => params.row.total ? 'total-row' : ''}
                slots={{toolbar: GridToolbar}}
                disableRowSelectionOnClick
            />
        </div>
    );
};

export default PartnerRevenueDataGrid;
